var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2691 15.3937C17.2772 14.1885 17.884 12.6362 17.884 10.9422C17.884 7.1084 14.776 4 10.942 4C7.108 4 4 7.1084 4 10.9422C4 14.776 7.108 17.8845 10.942 17.8845C12.5291 17.8845 13.9918 17.3518 15.1611 16.4555L18.708 19.7922C19.017 20.0816 19.502 20.0672 19.792 19.7587C20.082 19.4501 20.067 18.9653 19.759 18.6749L16.2691 15.3937ZM10.942 16.3514C7.955 16.3514 5.533 13.93 5.533 10.9422C5.533 7.9555 7.955 5.5331 10.942 5.5331C13.93 5.5331 16.351 7.9555 16.351 10.9422C16.351 13.93 13.93 16.3514 10.942 16.3514Z",
    fill: "#FBFBFB",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fc8c50f039d2b39b5744ad62e09a9eab.svg";
export { ForwardRef as ReactComponent };